import { httpRequest } from "@services/http";
import { bannersUrl, type Banner } from "./cmdListBanners";

export interface BannerPayload {
  message: string;
  link_text: string;
  link_url: string;
  starts_at: string | null;
  ends_at: string | null;
  is_draft: boolean;
}

/** The banner a 409 banner_overlap names in `details.conflict`. */
export interface BannerConflict {
  uuid: string;
  message: string;
  starts_at: string;
  ends_at: string | null;
}

export class CommandCreateBanner {
  async run(payload: BannerPayload): Promise<Banner> {
    try {
      return await httpRequest<Banner>(bannersUrl(), { method: "POST", body: payload });
    } catch (error) {
      console.error("Error creating banner:", error);
      throw error;
    }
  }
}
